'use strict';

/* Views */
import DirectoryEdit from './directory/edit/directory-edit.component';
import DirectoryList from './directory/list/directory-list.component';
import BusinessList from './business/business-directory.component';
import ImportantNumbers from './important-numbers/important-numbers.component';
import UserDirectory from './user/user-directory.component';
import ResidentDirectory from './resident/resident-directory.component';
import VendorList from './vendor/vendor-list.component';
import FAQList from './faq/list/faq-directory.component';
import FAQEdit from './faq/edit/faq-edit.component';
import SuiteDirectory from './suite/suite-directory.component';

/* Components */
import ImportantNumbersEditComponent from '../../components/important-numbers/edit/important-number-edit.component';

/* Services */
import BusinessService from '../../services/business/business.service';
import ImportantNumbersService from '../../services/important-numbers/important-number.service';

export default angular.module('conduuApp.directories', [DirectoryEdit, DirectoryList, BusinessList, ImportantNumbers,
  UserDirectory, VendorList, ImportantNumbersEditComponent, BusinessService, ImportantNumbersService, FAQList, FAQEdit,
  ResidentDirectory, SuiteDirectory])
  .name;



// WEBPACK FOOTER //
// ./client/app/directories/index.js